<template>
  <div class="customer">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="customer.customerID > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1200px"
        top="5vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="customer"
          :rules="ruleValidate"
          class="form"
          label-width="155px">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane v-if="editAuth" label="基础数据" name="first">
            <div class="vm-separate">
              <el-form-item label="编号">
                <el-input v-model="customer.customerNo" disabled/>
              </el-form-item>
              <el-form-item label="变量名">
                <el-input v-model="customer.variableName" disabled/>
              </el-form-item>
              <el-form-item label="外部编号" prop="outerNo">
                <el-input v-model="customer.outerNo" disabled/>
              </el-form-item>
            </div>
            <div class="vm-separate">
              <el-form-item label="客户类型">
                <div style="display: flex;flex-direction: row;">
                  <el-select v-model="customer.customerTypeName" clearable placeholder="请选择">
                    <el-option
                        v-for="item in customerTypeList"
                        :key="item.itemName"
                        :label="item.itemName"
                        :value="item.itemName"
                        @click.native="selectCustomerTypeName(item)"/>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="客户分组">
                <div style="display: flex;flex-direction: row;">
                  <el-select v-model="customer.customerGroup" clearable placeholder="请选择">
                    <el-option
                        v-for="item in customerGroups"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="等级">
                <div style="display: flex;flex-direction: row;">
                  <el-select v-model="customer.customerLevelName" clearable placeholder="请选择">
                    <el-option
                        v-for="item in customerLevelList"
                        :key="item.itemName"
                        :label="item.itemName"
                        :value="item.itemName"
                        @click.native="selectCustomerLevel(item)"/>
                  </el-select>
                </div>
              </el-form-item>
            </div>
            <div class="vm-separate">
              <el-form-item label="名称" prop="customerName">
                <el-input v-model="customer.customerName" disabled/>
              </el-form-item>
              <el-form-item label="简称">
                <el-input v-model="customer.shortName"/>
              </el-form-item>
              <el-form-item label="公司代码">
                <el-input v-model="customer.companyNo"/>
              </el-form-item>
            </div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="发货单销售员确认">
                  <el-radio-group v-model="customer.greenChannel">
                    <el-radio :label="false">是</el-radio>
                    <el-radio :label="true">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="是否优先">
                  <el-radio-group v-model="customer.isPriority">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开软件">
                  <el-radio-group v-model="customer.invoiceIncludeSoftware">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="是否终端客户">
                  <el-radio-group v-model="customer.isEndCustomer">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="是否机器人客户">
                  <el-radio-group v-model="customer.isRobot">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="包含明细">
                  <el-radio-group v-model="customer.invoiceIncludeDetail">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="vm-separate">
              <el-form-item label="联系人">
                <el-input v-model="customer.contact"/>
              </el-form-item>
              <el-form-item label="电话">
                <el-input v-model="customer.telephone"/>
              </el-form-item>
            </div>
            <div class="vm-separate">
              <el-form-item label="传真">
                <el-input v-model="customer.fax"/>
              </el-form-item>
              <el-form-item label="手机">
                <el-input v-model="customer.mobile"/>
              </el-form-item>
            </div>
            <div class="vm-separate">
              <el-form-item label="所属区域">
                <el-select v-model="customer.districtParentName" clearable placeholder="请选择">
                  <el-option
                      v-for="item in districtNameList"
                      :key="item.districtID"
                      :label="item.districtName"
                      :value="item.districtName"
                      @click.native="selectParentName(item)"/>
                </el-select>
                <el-select v-model="customer.districtName" clearable placeholder="请选择" filterable>
                  <el-option
                      v-for="item in districtNameLists"
                      :key="item.districtID"
                      :label="item.districtName"
                      :value="item.districtName"
                      @click.native="selectParentNames(item)"/>
                </el-select>
              </el-form-item>
              <el-form-item label="地址">
                <el-input v-model="customer.address"/>
              </el-form-item>
            </div>
            <div class="vm-separate">
              <el-form-item label="邮编">
                <el-input v-model="customer.postCode"/>
              </el-form-item>
              <el-form-item label="电子邮件">
                <el-input v-model="customer.email"/>
              </el-form-item>
            </div>
            <div class="vm-separate">
              <el-form-item label="税号">
                <el-input v-model="customer.vatno" disabled/>
              </el-form-item>
              <el-form-item label="开票地址">
                <el-input v-model="customer.invoiceAddress" disabled/>
              </el-form-item>
            </div>
            <div class="vm-separate">
              <el-form-item label="开户行">
                <el-input v-model="customer.bank" disabled/>
              </el-form-item>
              <el-form-item label="账号">
                <el-input v-model="customer.accounts" disabled/>
              </el-form-item>
            </div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="发货单财务审核">
                  <el-radio-group v-model="customer.belongto">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="销售订单财务审核">
                  <el-radio-group v-model="customer.salesOrderFinApprove">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="自定义收货地址">
                  <el-radio-group v-model="customer.allowCustomizeDeliveryAddress">
                    <el-radio :label="0">不允许</el-radio>
                    <el-radio :label="1">允许</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="销售订单销售员确认排产">
                  <el-radio-group v-model="customer.salesOrderSalesApprove">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="VMI">
                  <el-radio-group v-model="customer.allowVmi">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="系统">
                  <el-select
                      v-if="customer.customerID > 0"
                      v-model="customer.systemId"
                      disabled
                      clearable
                      placeholder="请选择">
                    <el-option
                        v-for="item in systemIds"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                  <el-select v-else v-model="customer.systemId" clearable placeholder="请选择">
                    <el-option
                        v-for="item in systemIds"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="备注">
              <el-input v-model="customer.note" type="text"/>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane v-if="editAuth" label="付款方式" name="second">
            <el-table
                ref="payData"
                :data="payData"
                @select="selectOne"
                @select-all="selectAll">
              <el-table-column type="selection" align="center" width="55"/>
              <el-table-column prop="payNodeType" label="全选"/>
            </el-table>
          </el-tab-pane>
          <el-tab-pane v-if="editAuth" label="所属销售员" name="third">
            <el-button type="primary" style="margin-bottom: 1%" @click="$refs.selectEmployee.open()">
              +添加
            </el-button>
            <employee-select ref="selectEmployee" @select="onSelectEmployee"/>
            <el-table :data="tableData">
              <el-table-column prop="employeeNo" label="员工编号" align="center"/>
              <el-table-column prop="employeeName" label="所属销售员" align="center"/>
              <el-table-column prop="mobile" label="联系电话" align="center"/>
              <el-table-column prop="isDefault" label="是否为默认销售员" align="center">
                <template slot-scope="scope">
                  <!--                  <el-switch-->
                  <!--                      v-model="scope.row.isDefault"-->
                  <!--                      active-text="是"-->
                  <!--                      inactive-text="否"/>-->
                  <el-radio-group v-model="scope.row.isDefault"
                                  @change="changeIsDefault(scope.row.isDefault,scope.$index)">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="danger" @click="oneDelete(scope.$index,scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane v-if="editProgramAuth" label="客户程序维护" name="fourth">
            <el-button type="primary" style="margin-bottom: 1%" @click="$refs.selectMaterial.open()">
              +添加
            </el-button>
            <material-select ref="selectMaterial" @select="selectMaterial"/>
            <el-table :data="tableDataMaterial">
              <el-table-column align="center" prop="materialNO" label="物料号" width="120px"/>
              <el-table-column align="center" prop="note" label="程序代码">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.note" class="tabInput" style="width: 400px;margin: 0 auto"/>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120px">
                <template slot-scope="scope">
                  <el-button type="danger" @click="materialDelete(scope.$index,scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import constant from "@/util/constant";
  import MaterialSelect from "@/views/information/SupplierManage/MaterialSelect";

  export default {
    name: "CustomerEdit",
    components: {MaterialSelect, EmployeeSelect},
    data() {
      return {
        constant,
        editAuth: this.$auth(16),
        editProgramAuth: this.$auth(720),
        systemIds: constant.toSelect(constant.systemIds),
        customerGroups: constant.toSelect(constant.customerGroup),
        customerTypeList: [],
        customerLevelList: [],
        activeName: "first",
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        checkAll: false,
        tableData: [],
        tableDataMaterial: [],
        payData: [],
        districtNameList: [],
        districtNameLists: [],
        deleteIds: [],
        name1: "",
        idList: "",
        customer: {
          customerID: "",
          customerNo: "",
          customerName: "",
          companyNo: "S100",
          outerNo: "",
          shortName: "",
          customerType: "",
          customerTypeName: "",
          customerLevel: "",
          customerLevelName: "",
          belongto: 1,
          isPriority: false,
          salesOrderFinApprove: true,
          salesOrderSalesApprove: true,
          contact: "",
          telephone: "",
          fax: "",
          postCode: "",
          address: "",
          mobile: "",
          email: "",
          logo: "",
          parentID: "",
          note: "",
          isDetail: "",
          districtID: "",
          bank: "",
          accounts: "",
          vatno: "",
          invoiceAddress: "",
          createdTime: "",
          greenChannel: false,
          photoPath: "",
          variableName: "",
          invoiceIncludeDetail: false,
          invoiceIncludeSoftware: false,
          isEndCustomer: false,
          isRobot: false,
          allowVmi: false,
          districtName: "",
          districtParentName: "",
          employeeNames: "",
          pmIds: [],
          customerBelongtoEmployeeVOS: [],
          customerMaterialProgramList: [],
          allowCustomizeDeliveryAddress: 0,
          customerGroup: 10,
          systemId: 10,
        },
        ruleValidate: {
          outerNo: {required: true, message: "外部编号不能为空", trigger: "blur"},
          customerName: {required: true, message: "名称不能为空", trigger: "blur"},
          // districtName:{required: true, message: "所属区域不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.customer.customerID = id;
        this.dialogVisible = true;
        this.getParentNameList();
        this.getThirdLevelList();
        this.getCustomerTypeList();
        this.getCustomerLevelList();
        this.getPayData();
        if (id > 0) {
          this.getData();
          this.getTableData();
        } else {
          this.getNode();
        }
      },
      getParentNameList() {
        this.$http
            .get("basic", "districts/firstLevelList")
            .then(resp => {
              this.districtNameList = resp;
            });
      },
      changeIsDefault(isDefault, index) {
        this.$nextTick(() => {
          if (isDefault) {
            for (let i = 0; i < this.tableData.length; i++) {
              if (i !== index) {
                this.tableData[i].isDefault = false;
              }
            }
          }
        });

      },
      getThirdLevelList() {
        this.$http
            .get("basic", "districts/thirdLevelList")
            .then(resp => {
              this.districtNameLists = resp;
            });
      },
      getData() {
        this.contentLoading = true;
        this.$http
            .get("basic", `customers/${this.customer.customerID}`)
            .then(resp => {
              console.log(resp);
              this.customer = resp;
              this.tableDataMaterial = resp.customerMaterialProgramList;
              this.customer.variableName = "C" + this.customer.customerNo;
              this.contentLoading = false;
              let checkPayList = [];
              for (let item of this.payData) {
                for (let id of this.customer.pmIds) {
                  if (item.pmid === id) {
                    checkPayList.push(item);
                  }
                }
              }
              if (checkPayList.length > 0) {
                this.toggleSelection(checkPayList);
              }
            });
      },
      getNode() {
        this.$http
            .get("basic", "customers/selectNo")
            .then(resp => {
              this.customer.customerNo = resp;
              this.customer.variableName = "C" + resp;
            });
      },
      getCustomerTypeList() {
        this.$http
            .get("basic", "systemItems/customerType")
            .then(resp => {
              this.customerTypeList = resp;
            });
      },
      getCustomerLevelList() {
        let type = "CustomerLevel";
        this.$http
            .get("basic", `systemItems/selectByItemType/${type}`)
            .then(resp => {
              this.customerLevelList = resp;
            });
      },
      selectCustomerLevel(item) {
        this.customer.customerLevel = item.itemID;
      },
      selectParentName(item) {
        this.customer.parentID = item.districtID;
        this.customer.districtParentName = item.districtName;
      },
      selectParentNames(item) {
        this.customer.districtID = item.districtID;
        this.customer.districtName = item.districtName;
      },
      selectCustomerTypeName(item) {
        this.customer.customerType = item.itemID;
      },
      selectMaterial(row) {
        console.log(row);
        for (let item of this.tableDataMaterial) {
          if (item.pkId === row.id) {
            this.$message.error("物料已存在，请勿重复添加");
            return;
          }
        }
        this.tableDataMaterial.push({
          materialNO: row.no,
          pkId: row.id,
          note: "",
        });
      },
      getPayData() {
        this.$http
            .get("basic", "payManners/list")
            .then(resp => {
              this.payData = resp;
            });
      },
      getTableData() {
        this.$http
            .get("basic", `customerBelongtoEmployees/customerId/${this.customer.customerID}`)
            .then(resp => {
              this.tableData = resp;
            });
      },
      onSelectEmployee(row) {
        let flag = false;
        for (let item of this.tableData) {
          if (item.employeeID === row.employeeID) {
            flag = true;
            break;
          }
        }
        if (!flag) {
          let isDefault = false;
          if (this.tableData.length == 0) {
            isDefault = true;
          }
          let params = {
            customerID: this.customer.customerID,
            employeeID: row.employeeID,
            employeeNo: row.employeeNO,
            employeeName: row.employeeName,
            mobile: row.mobile,
            isDefault: isDefault,
            isDeleted: 0,
          };
          this.tableData.push(params);
          // this.addEmployee(params);
        } else {
          this.$message.error("不能重复添加人员");
        }
      },
      // addEmployee(params) {
      //   this.$http
      //     .post("basic", "customerBelongtoEmployees", params)
      //     .then(() => {
      //       this.getTableData();
      //       this.$message.success("添加成功");
      //     })
      //     .catch(() => {
      //       this.$message.error("添加失败");
      //     });
      // },
      oneDelete(index, row) {
        this.tableData.splice(index, 1);
        this.$message.success("删除成功");
        if (row.pkid) {
          let parms = {
            customerID: this.customer.customerID,
            employeeID: row.employeeID,
          };
          this.deleteIds.push(parms);
        }
      },
      materialDelete(index) {
        this.tableDataMaterial.splice(index, 1);
        this.$message.success("删除成功");
      },
      //数据库真正删除
      delete() {
        this.$http
            .delete("basic", "customerBelongtoEmployees/idList", this.deleteIds).then(() => {
          this.deleteIds = [];
        });
      },
      selectOne(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.payData.toggleRowSelection(row);
          });
        }
        // } else {
        //   this.$refs.payData.clearSelection();
        // }
      },
      handleSubmit() {
        if (this.deleteIds.length) {
          this.delete();
        }
        this.customer.pmIds = [];
        if (this.idList.length > 0) {
          for (let item of this.idList) {
            this.customer.pmIds.push(item.pmid);
          }
        }
        let isAllFalse = true;
        for (let item of this.tableData) {
          if (item.isDefault)
            isAllFalse = false;
        }
        if (isAllFalse) {
          return this.$message.error("请选择一个默认销售员");
        }
        console.log(this.customer.districtName);
        // if (this.customer.districtName== null || this.customer.districtName==="") {
        //   this.$message.error("请维护基础数据里面的所属区域");
        // }
        if (this.customer.customerID > 0) {
          this.handleSubmitPut();
        } else {
          this.handleSubmitPost();
        }
      },
      handleSubmitPut() {
        this.customer.customerBelongtoEmployeeVOS = this.tableData;
        this.customer.customerMaterialProgramList = this.tableDataMaterial;
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .put("basic", "customers", this.customer)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
      handleSubmitPost() {
        this.customer.customerBelongtoEmployeeVOS = this.tableData;
        this.customer.customerMaterialProgramList = this.tableDataMaterial;
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .post("basic", "customers", this.customer)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
.customer .el-radio-group {
  margin-top: 6px;
}

.tabInput {
  input {
    text-align: center !important;
  }
}
</style>
